import React, {
  Fragment,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import Header from "../common/Header";
import {
  Button,
  Drawer,
  FormControl,
  FormControlLabel,
  Grid,
  Modal,
  Radio,
  RadioGroup,
  Skeleton,
  Typography,
} from "@mui/material";
import {
  StyledComponentGroup,
  StyledMobButtons,
  StyledProducts,
  StyledProductsWrapper,
} from "./styled";
import ReplayIcon from "@mui/icons-material/Replay";
import RepeatIcon from "@mui/icons-material/Repeat";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Reason from "./reason";
import { motion } from "framer-motion";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { getEncipherencode } from "utils/encipherencode";
import styled from "styled-components";
import { getMerchantConfig, getRmsConfig } from "features/config/configSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getSelectedOrder,
  getWebSelected,
  updateSelectedOrder,
  updateUUID,
  updateWebSelected,
} from "features/orders/orderSlice";
import { selectedOrderAPI } from "utils/api";
import {
  addSelectedProduct,
  addProductid,
  getProductid,
  getSelectedMob,
  mobSelected,
  addSelectedReason,
  addSelectedSubReason,
  setImageUploads,
  addPreviews,
  addUploads,
  addProductType,
  addProceedBool,
  addSelectedGroupProducts,
  setReplacementMode,
} from "features/product/productSlice";
import {
  addRefundJSON,
  addRefundSource,
  getRefundJSON,
  getRefundSource,
  getReturnedProducts,
} from "features/returnedProducts/returnedProductSlice";
import { getEmail, getPhone } from "features/user/userSlice";
import CloseIcon from "@mui/icons-material/Close";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CartProducts from "components/v1/common/CartProducts/CartProducts";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { format } from "date-fns";
import LoadingError from "components/v1/common/LoadingError";
import { getAddress, getShipmentMethod } from "features/address/addresSlice";
import { saveReturnCartContext } from "utils/returnCartSession";
import {
  hasValidTrackingReference,
  stripVersionPrefix,
  versionedPath,
} from "utils/routes";
import {
  formatRequestWindow,
  getAggregatedRequestWindows,
  resolveRequestWindows,
} from "utils/requestWindows";
import { isLineItemReplacementEligible } from "utils/replacementEligibility";
// import cartImage from "assets/cart.svg";

function ProductsDisplay() {
  const merchantConfig = useSelector(getMerchantConfig);
  const defaultSelectedOrder = useSelector(getSelectedOrder);
  const selected = useSelector(getSelectedMob);
  const returnedProducts = useSelector(getReturnedProducts);
  const rmsConfig = useSelector(getRmsConfig);
  const webSelected = useSelector(getWebSelected);
  const [isDesktopReasonLayout, setIsDesktopReasonLayout] = useState(
    () => window.innerWidth > 900,
  );
  const userPhone = useSelector(getPhone);
  const userEmail = useSelector(getEmail);
  const defaultProductid = useSelector(getProductid);
  const addressDetails = useSelector(getAddress);
  const shipmentMethod = useSelector(getShipmentMethod);
  const refundSource = useSelector(getRefundSource);
  const refundJSON = useSelector(getRefundJSON);

  const [productid, setProductid] = useState(defaultProductid);
  const dispatch = useDispatch();
  const [selectedOrder, setSelectedOrder] = useState(defaultSelectedOrder);
  const [productsLoading, setProductsLoading] = useState(true);
  const [apiErrorLoading, setApiErrorLoading] = useState(false);
  const [incentiviseExchangeModalOpen, setIncentiviseExchangeModalOpen] =
    useState(false);
  const [pendingIncentiviseSelection, setPendingIncentiviseSelection] =
    useState(null);
  const [selectedProduct, setSelectedProduct] = useState({});
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const updateViewportLayout = () => {
      setIsDesktopReasonLayout(window.innerWidth > 900);
    };

    updateViewportLayout();
    window.addEventListener("resize", updateViewportLayout);
    return () => {
      window.removeEventListener("resize", updateViewportLayout);
    };
  }, []);
  const [updatedReturnedProducts, setUpdatedReturnedProducts] =
    useState(returnedProducts);
  const [expandedGroupKey, setExpandedGroupKey] = useState(null);
  const [activeGroupAction, setActiveGroupAction] = useState(null);
  const [isReplacementAction, setIsReplacementAction] = useState(false);

  const closeReasonFlow = useCallback(() => {
    dispatch(updateWebSelected(false));
    dispatch(mobSelected(false));
  }, [dispatch]);

  const resetReasonDraft = useCallback(() => {
    closeReasonFlow();
    dispatch(addSelectedReason(null));
    dispatch(addSelectedSubReason(null));
    dispatch(setImageUploads([]));
    dispatch(addPreviews([]));
    dispatch(addUploads([]));
    dispatch(addProductType(null));
    dispatch(addProceedBool(false));
    dispatch(setReplacementMode(false));
    dispatch(addProductid(null));
    setProductid(null);
  }, [closeReasonFlow, dispatch]);

  const resetSelectionForNewGroup = useCallback(() => {
    resetReasonDraft();
    setIncentiviseExchangeModalOpen(false);
    setPendingIncentiviseSelection(null);
  }, [resetReasonDraft]);

  const createParentFromChild = (child) => {
    if (!child) {
      return null;
    }

    const parentPrice =
      child.parent_product_price !== null &&
      child.parent_product_price !== undefined
        ? child.parent_product_price
        : child.product_price;

    return {
      line_item_id: child.parent_item_id,
      product_title: child.parent_title || child.product_title,
      variant_name: child.parent_variant || "",
      sku: child.parent_product_sku || "",
      quantity: child.parent_quantity || child.quantity,
      remaining_qty: child.parent_quantity || child.quantity,
      product_price: parentPrice,
      discounted_price: parentPrice,
      original_product_price: parentPrice,
      total_item_discount: 0,
      parent_image_url: child.parent_image_url,
      image_url: child.parent_image_url || child.image_url,
    };
  };

  const dedupeErrors = (errors = []) => {
    if (!errors || errors.length === 0) {
      return [];
    }

    const uniqueErrors = [];
    const seen = new Set();

    errors.forEach((error) => {
      if (!error) {
        return;
      }

      const key = `${error.error_code || ""}-${error.error_code_message || ""}`;

      if (!seen.has(key)) {
        seen.add(key);
        uniqueErrors.push(error);
      }
    });

    return uniqueErrors;
  };

  const normalizeErrors = (errors = []) => {
    const uniqueErrors = dedupeErrors(errors);
    return uniqueErrors.length > 0 ? [uniqueErrors[0]] : [];
  };

  const getLineItemReferenceId = (product) =>
    product?.reference_id ||
    product?.return_reference_id ||
    product?.return_request_reference_id ||
    product?.request_reference_id ||
    product?.tracking_reference_id ||
    null;

  const groupedOrderItems = useMemo(() => {
    const items = selectedOrder?.order_items || [];
    const map = new Map();
    const orderKeys = [];

    const getGroupKey = (item) => {
      if (item.sku_type === "bundle") {
        if (
          // item.wms &&
          // item.wms?.toLowerCase() === "easyecom" &&
          item.parent_item_id
        ) {
          return `wms-${item.parent_item_id}`;
        }

        if (item.wms_item_id) {
          return `wms-${item.wms_item_id}`;
        }
      }

      return `single-${item.line_item_id}`;
    };

    items.forEach((item) => {
      const key = getGroupKey(item);

      if (!map.has(key)) {
        map.set(key, []);
        orderKeys.push(key);
      }

      map.get(key).push(item);
    });

    return orderKeys.map((key) => {
      const members = map.get(key) || [];

      const isGroupKey = key.startsWith("wms-") || key.startsWith("parent-");

      if (!isGroupKey) {
        return { type: "single", item: members[0] };
      }

      const parentCandidate = members.find((member) => member.is_parent);
      const children = parentCandidate
        ? members.filter(
            (member) => member.line_item_id !== parentCandidate.line_item_id,
          )
        : members;

      if (!children || children.length === 0) {
        return { type: "single", item: parentCandidate || members[0] };
      }

      const parentSource =
        parentCandidate ||
        children.find(
          (child) =>
            child.parent_title ||
            child.parent_variant ||
            child.parent_product_sku ||
            child.parent_image_url,
        ) ||
        children[0];

      const derivedParent =
        parentCandidate || createParentFromChild(parentSource);

      if (!derivedParent) {
        return { type: "single", item: children[0] };
      }

      const parentDetails = parentCandidate
        ? { ...derivedParent }
        : derivedParent;

      return {
        type: "group",
        key,
        parent: parentDetails,
        children,
      };
    });
  }, [selectedOrder?.order_items]);

  const customerCanExchange = Boolean(
    !rmsConfig.only_replacement &&
      (rmsConfig.supports_exchange || selectedOrder?.force_exchange),
  );

  const aggregateGroupProduct = (parent, children) => {
    if (!children || children.length === 0) {
      return parent || {};
    }

    const some = (callback) => children.some((child) => callback(child));
    const every = (callback) =>
      children.length > 0 && children.every((child) => callback(child));

    const aggregated = {
      ...parent,
    };

    aggregated.is_delivered =
      parent?.is_delivered !== undefined && parent?.is_delivered !== null
        ? parent.is_delivered
        : some((child) => child.is_delivered);

    aggregated.delivery_date_expired =
      parent?.delivery_date_expired !== undefined &&
      parent?.delivery_date_expired !== null
        ? parent.delivery_date_expired
        : every((child) => child.delivery_date_expired);

    aggregated.eligible =
      parent?.eligible !== undefined
        ? parent.eligible
        : some((child) => child.eligible);

    aggregated.remaining_qty =
      parent?.remaining_qty !== undefined && parent?.remaining_qty !== null
        ? parent.remaining_qty
        : children.reduce((total, child) => {
            if (
              child.remaining_qty !== undefined &&
              child.remaining_qty !== null
            ) {
              return total + child.remaining_qty;
            }
            if (child.quantity !== undefined && child.quantity !== null) {
              return total + child.quantity;
            }
            return total;
          }, 0);

    aggregated.returned_qty =
      parent?.returned_qty !== undefined && parent?.returned_qty !== null
        ? parent.returned_qty
        : children.reduce(
            (total, child) => total + (child.returned_qty || 0),
            0,
          );

    aggregated.reference_id =
      getLineItemReferenceId(parent) ||
      children.map((child) => getLineItemReferenceId(child)).find(Boolean) ||
      null;

    aggregated.refund_eligible =
      parent?.refund_eligible !== undefined && parent?.refund_eligible !== null
        ? parent.refund_eligible
        : some((child) => child.refund_eligible);

    aggregated.exchange_eligible =
      parent?.exchange_eligible !== undefined &&
      parent?.exchange_eligible !== null
        ? parent.exchange_eligible
        : some((child) => child.exchange_eligible);

    aggregated.replacement =
      parent?.replacement !== undefined && parent?.replacement !== null
        ? parent.replacement
        : some((child) => child.replacement);

    aggregated.exchange_date_expired =
      parent?.exchange_date_expired !== undefined &&
      parent?.exchange_date_expired !== null
        ? parent.exchange_date_expired
        : every((child) => child.exchange_date_expired);

    aggregated.return_date_expired =
      parent?.return_date_expired !== undefined &&
      parent?.return_date_expired !== null
        ? parent.return_date_expired
        : every((child) => child.return_date_expired);

    Object.assign(
      aggregated,
      getAggregatedRequestWindows(parent, children),
    );

    aggregated.refund_restrict_msg =
      parent?.refund_restrict_msg !== undefined &&
      parent?.refund_restrict_msg !== null
        ? parent.refund_restrict_msg
        : children.find((child) => child.refund_restrict_msg)
            ?.refund_restrict_msg ||
          parent?.refund_restrict_msg ||
          null;

    aggregated.exchange_restrict_msg =
      parent?.exchange_restrict_msg !== undefined &&
      parent?.exchange_restrict_msg !== null
        ? parent.exchange_restrict_msg
        : children.find((child) => child.exchange_restrict_msg)
            ?.exchange_restrict_msg ||
          parent?.exchange_restrict_msg ||
          null;

    const parentErrors = normalizeErrors(parent?.errors || []);

    const hasEligibleChild = some((child) => {
      if (!child) {
        return false;
      }

      const remainingQuantity =
        child.remaining_qty !== undefined && child.remaining_qty !== null
          ? child.remaining_qty
          : child.quantity;

      if (!remainingQuantity || remainingQuantity <= 0) {
        return false;
      }

      if (!child.is_delivered || child.is_delivered === null) {
        return false;
      }

      if (child.delivery_date_expired) {
        return false;
      }

      const canReturn = !child.return_date_expired && child.refund_eligible;

      const canExchange =
        customerCanExchange &&
        !child.exchange_date_expired &&
        child.exchange_eligible;

      const canReplace =
        rmsConfig.supports_replacement &&
        !child.exchange_date_expired &&
        child.replacement;

      return canReturn || canExchange || canReplace;
    });

    const childErrors = normalizeErrors(
      children.flatMap((child) => child.errors || []),
    );

    aggregated.errors =
      parentErrors.length > 0
        ? parentErrors
        : hasEligibleChild
          ? []
          : childErrors;

    return aggregated;
  };

  const isReplacementAvailable = (item) =>
    Boolean(
      rmsConfig.supports_replacement && isLineItemReplacementEligible(item),
    );

  const getChildActionState = (child, actionType, isReplacement = false) => {
    if (!child || !actionType) {
      return { selectable: false, message: null };
    }

    if (!child.is_delivered || child.is_delivered === null) {
      return {
        selectable: false,
        message: "The item is yet to be delivered",
      };
    }

    if (child.delivery_date_expired) {
      return {
        selectable: false,
        message: `${
          rmsConfig.only_replacement
            ? "Replacement"
            : rmsConfig.supports_exchange && rmsConfig.supports_refund
              ? "Return/Exchange"
              : rmsConfig.supports_exchange
                ? "Exchange"
                : "Return"
        } period is expired`,
      };
    }

    const remainingQuantity =
      child.remaining_qty !== undefined && child.remaining_qty !== null
        ? child.remaining_qty
        : child.quantity;

    if (!remainingQuantity || remainingQuantity <= 0) {
      const referenceId = getLineItemReferenceId(child);
      return {
        selectable: false,
        referenceId,
        message: `You've already placed a ${
          rmsConfig.only_replacement ? "replacement" : "return/exchange"
        } for this item.${
          referenceId
            ? ""
            : " Please reach out to us by clicking on the Need Help button at the bottom of the page for further assistance."
        }`,
      };
    }

    if (actionType === "return") {
      if (child.return_date_expired) {
        return {
          selectable: false,
          message: "Return period is expired for this item",
        };
      }

      if (!child.refund_eligible) {
        return {
          selectable: false,
          message:
            child.refund_restrict_msg ||
            "This item is not eligible for return",
        };
      }
    }

    if (actionType === "exchange") {
      if (child.exchange_date_expired) {
        return {
          selectable: false,
          message: "Exchange period is expired for this item",
        };
      }

      if (isReplacement) {
        if (!isReplacementAvailable(child)) {
          return {
            selectable: false,
            message: "Replacement is not available for this item.",
          };
        }
      } else if (!child.exchange_eligible) {
        return {
          selectable: false,
          message:
            child.exchange_restrict_msg ||
            "This item is not eligible for exchange.",
        };
      }
    }

    // if (child.errors?.length > 0) {
    //   return {
    //     selectable: false,
    //     message: child.errors[0].error_code_message,
    //   };
    // }

    return { selectable: true, message: null };
  };

  const handleGroupActionSelection = useCallback(
    (groupKey, actionType, options = {}) => {
      if (!groupKey || !actionType) {
        return;
      }

      const normalizedAction = actionType;
      const replacementSelected = Boolean(options.isReplacement);
      const isSameGroup = expandedGroupKey === groupKey;
      const isSameSelection =
        isSameGroup &&
        activeGroupAction === normalizedAction &&
        isReplacementAction === replacementSelected;

      if (isSameSelection) {
        resetSelectionForNewGroup();
        setExpandedGroupKey(null);
        setActiveGroupAction(null);
        setIsReplacementAction(false);
        return;
      }

      const selectionChanged =
        !isSameGroup ||
        activeGroupAction !== normalizedAction ||
        isReplacementAction !== replacementSelected;

      if (selectionChanged) {
        resetSelectionForNewGroup();
      }

      setExpandedGroupKey(groupKey);
      setActiveGroupAction(normalizedAction);
      setIsReplacementAction(replacementSelected);
    },
    [
      activeGroupAction,
      expandedGroupKey,
      isReplacementAction,
      resetSelectionForNewGroup,
    ],
  );

  const eligibleDisplayItems = useMemo(
    () =>
      groupedOrderItems.filter((entry) => {
        if (entry.type === "single") {
          return entry.item.visible && entry.item.eligible;
        }

        return entry.children.some((child) => child.visible && child.eligible);
      }),
    [groupedOrderItems],
  );

  const ineligibleDisplayItems = useMemo(
    () =>
      groupedOrderItems.filter((entry) => {
        if (entry.type === "single") {
          return !entry.item.eligible;
        }

        return entry.children.every((child) => !child.eligible);
      }),
    [groupedOrderItems],
  );

  const { hasReplacementOnly } = useMemo(() => {
    let hasReplacement = false;
    let hasExchange = false;
    let hasReturn = false;

    eligibleDisplayItems.forEach((entry) => {
      const items =
        entry.type === "group"
          ? entry.children
          : entry.item
            ? [entry.item]
            : [];

      items.forEach((item) => {
        if (!item || !item.visible || !item.eligible) {
          return;
        }

        if (isReplacementAvailable(item)) {
          hasReplacement = true;
        }

        if (customerCanExchange && item.exchange_eligible) {
          hasExchange = true;
        }

        if (item.refund_eligible) {
          hasReturn = true;
        }
      });
    });

    return {
      hasReplacementOnly: hasReplacement && !hasExchange && !hasReturn,
    };
  }, [customerCanExchange, eligibleDisplayItems, rmsConfig.supports_replacement]);

  const [params] = useSearchParams();
  const encipherencode = getEncipherencode(params);
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = stripVersionPrefix(location.pathname);

  const openTrackingRequest = (referenceId) => {
    if (!hasValidTrackingReference(referenceId)) {
      return;
    }

    const trackingParams = new URLSearchParams();
    if (encipherencode) {
      trackingParams.set("encipherencode", encipherencode);
    }
    trackingParams.set("rid", referenceId);

    navigate(`/tracking?${trackingParams.toString()}`);
  };

  function updateProductsList(order) {
    let productset = [];
    let updatedOrder = { ...order };

    if (returnedProducts !== undefined) {
      if (returnedProducts.length > 0) {
        productset = updatedOrder.order_items.filter(
          (a) =>
            !returnedProducts
              .map((a) => a.line_item_id)
              .includes(a.line_item_id),
        );
        let remainingProducts = updatedOrder.order_items.filter((a) =>
          returnedProducts.map((a) => a.line_item_id).includes(a.line_item_id),
        );
        for (let i = 0; i < returnedProducts.length; i++) {
          for (let j = 0; j < remainingProducts.length; j++) {
            if (
              returnedProducts[i].line_item_id ===
                remainingProducts[j].line_item_id &&
              returnedProducts[i].remaining_qty > 0
            ) {
              remainingProducts[j] = {
                ...remainingProducts[j],
                remaining_qty: returnedProducts[i].remaining_qty,
              };
              productset.push(remainingProducts[j]);
            }
          }
        }
        const returnedProductGroupIds = returnedProducts
          .map((a) => a.product_group_id)
          .filter((id) => id !== null && id !== undefined);

        updatedOrder.order_items = productset.filter(
          (product) =>
            !returnedProductGroupIds.includes(product.product_group_id),
        );
      }
      setSelectedOrder(updatedOrder);
    }
  }
  useEffect(() => {
    setUpdatedReturnedProducts(returnedProducts);
  }, [returnedProducts]);

  useEffect(() => {
    updateProductsList(defaultSelectedOrder);
  }, [updatedReturnedProducts]);

  useEffect(() => {
    if (
      merchantConfig &&
      merchantConfig.merchant_id !== null &&
      selectedOrder &&
      selectedOrder.order_id &&
      selectedOrder.order_id !== null
    ) {
      selectedOrderAPI(selectedOrder)
        .then((resp) => {
          dispatch(updateSelectedOrder(resp.data.order));
          dispatch(updateUUID(resp.data.unique_id));
          if (currentPath === "/products") {
            updateProductsList(resp.data.order);
            // setSelectedOrder(resp.data.order);
          }
          setProductsLoading(false);
        })
        .catch((err) => {
          if (userPhone === "" && userEmail === "") {
            let url = "/";
            if (encipherencode) {
              url += `?encipherencode=${encipherencode}`;
            }
            navigate(url);
          } else {
            setApiErrorLoading(true);
          }
        });
      dispatch(updateWebSelected(false));
      dispatch(mobSelected(false));
      dispatch(addProductid(null));
      setProductid(null);
      dispatch(addRefundSource(null));
      dispatch(addRefundJSON({}));
    }
  }, []);

  const styles = {
    infoMessage: {
      color: "#3B444DB2",
      fontSize: "14px",
      padding: "1rem",
    },
    button: {
      padding:
        rmsConfig.button_version === "v2" ? "5px 6px 10px 1rem" : "2px 1rem",
      borderRadius: merchantConfig.use_rounded_edge_buttons ? "10px" : "0px",
      fontWeight: "700",
      fontSize: "16px"
    },
    incentiviseMessage: {
      color: rmsConfig.button_promotional_text_color
        ? rmsConfig.button_promotional_text_color
        : "#16AC37",
    },
  };

  const proceedActionText = hasReplacementOnly
    ? " Replace"
    : customerCanExchange && rmsConfig.supports_refund
      ? " Return/Exchange"
      : customerCanExchange
        ? " Exchange"
        : " Return";

  const openReasonFlow = useCallback(
    (returnType, flowProduct, options = {}) => {
      if (!flowProduct) {
        return;
      }

      handleOnSelect(returnType, flowProduct, options);

      if (isDesktopReasonLayout) {
        dispatch(updateWebSelected(true));
        dispatch(mobSelected(false));
      } else {
        dispatch(mobSelected(true));
        dispatch(updateWebSelected(false));
      }

      setIncentiviseExchangeModalOpen(false);
      setPendingIncentiviseSelection(null);
    },
    [dispatch, isDesktopReasonLayout],
  );

  // Helper function to render buttons
  const BUTTON_CONTAINER_GAP = 10;
  const MIN_BUTTON_WIDTH = 140;

  const renderButton = (
    label,
    onClick,
    disabled,
    icon,
    style = {},
    chargesStatement,
    buttonType,
    isActive = false,
  ) => {
    const themeColor = merchantConfig.primary_theme_color || "#1d8dcc";
    const resolvedType =
      buttonType ||
      (label === "Exchange" || label === "Replace" ? "exchange" : "return");
    const isContained =
      resolvedType === "exchange" || resolvedType === "replace";
    const activeStyles = isActive
      ? isContained
        ? {
            backgroundColor: themeColor,
            borderColor: themeColor,
            color: "#fff",
          }
        : {
            borderColor: themeColor,
            color: themeColor,
            backgroundColor: `${themeColor}1A`,
          }
      : {};

    const buttonClassNames = ["rms-btns"];
    if (label === "Exchange") {
      buttonClassNames.push("exchange-button");
    }
    if (isActive) {
      buttonClassNames.push("active");
    }

    const resolvedVariant = isContained ? "contained" : "outlined";

    return (
      <Button
        className={buttonClassNames.join(" ")}
        variant={resolvedVariant}
        color="primary"
        onClick={onClick}
        disabled={disabled}
        startIcon={icon}
        style={{ ...styles.button, ...style, ...activeStyles }}
      >
        {label}
        <span className="charges-statement">{chargesStatement}</span>
      </Button>
    );
  };

  const renderTrackRequestButton = (referenceId) => {
    if (!hasValidTrackingReference(referenceId)) {
      return null;
    }

    return (
      <div className="button-container track-request-container">
        {renderButton(
          "Track Request",
          () => openTrackingRequest(referenceId),
          false,
          <OpenInNewIcon />,
          {
            width: "100%",
            maxWidth: "100%",
            flexBasis: "100%",
            background: "#f9fafc",
            border: `1px solid ${merchantConfig.primary_theme_color}`,
          },
          null,
          "return",
        )}
      </div>
    );
  };

  const RefundButtons = ({ product, onActionClick, selectedAction }) => {
    // Helper function to render restriction messages
    const renderRestrictionMessage = (message) => (
      <p className="info-message">{message}</p>
    );

    const requestWindows = resolveRequestWindows({
      subject: product,
      rmsConfig,
      deliveredAt: product.delivered_at || selectedOrder.delivered_at,
      forceExchange: selectedOrder.force_exchange,
    });

    const renderExpiryInfo = (showExchange, showReturn, style = {}) => {
      const exchangeLabel = rmsConfig.only_replacement
        ? "Replacement"
        : "Exchange";
      const showCombined =
        showExchange && showReturn && requestWindows.sameDate;

      if (
        (!showReturn || !requestWindows.returnDate) &&
        (!showExchange || !requestWindows.exchangeDate)
      ) {
        return null;
      }

      return (
        <div className="expiry-info" style={style}>
          {showCombined ? (
            <p>
              <AccessTimeIcon fontSize="small" /> Return/{exchangeLabel} before{" "}
              {formatRequestWindow(requestWindows.returnDate, "MMM do yyyy")}
            </p>
          ) : (
            <>
              {showExchange && requestWindows.exchangeDate && (
                <p>
                  <AccessTimeIcon fontSize="small" /> {exchangeLabel} before{" "}
                  {formatRequestWindow(
                    requestWindows.exchangeDate,
                    "MMM do yyyy",
                  )}
                </p>
              )}
              {showReturn && requestWindows.returnDate && (
                <p>
                  <AccessTimeIcon fontSize="small" /> Return before{" "}
                  {formatRequestWindow(
                    requestWindows.returnDate,
                    "MMM do yyyy",
                  )}
                </p>
              )}
            </>
          )}
        </div>
      );
    };

    const openExchangeFlow = (isReplacement = false) => {
      openReasonFlow("exchange", product, { isReplacement });
    };

    const openReturnFlow = () => {
      if (
        rmsConfig.exchange_nudge_on_return_click &&
        customerCanExchange &&
        !product.exchange_date_expired &&
        product.exchange_eligible
      ) {
        resetReasonDraft();
        setPendingIncentiviseSelection({
          product,
          returnType: "return",
          isReplacement: false,
        });
        setIncentiviseExchangeModalOpen(true);
      } else {
        openReasonFlow("return", product, { isReplacement: false });
      }
    };

    const handleExchangeClick = (isReplacement = false) => {
      if (onActionClick) {
        onActionClick("exchange", { isReplacement });
        return;
      }
      openExchangeFlow(isReplacement);
    };

    const handleReturnClick = () => {
      if (onActionClick) {
        onActionClick("return", { isReplacement: false });
        return;
      }
      openReturnFlow();
    };

    const isExchangeActive =
      selectedAction?.type === "exchange" && !selectedAction?.isReplacement;
    const isReplaceActive =
      selectedAction?.type === "exchange" && selectedAction?.isReplacement;
    const isReturnActive = selectedAction?.type === "return";
    const trackingReferenceId = getLineItemReferenceId(product);

    // Conditions
    if (!product.is_delivered || product.is_delivered == null) {
      return <p className="info-message">The item is yet to be delivered</p>;
    }

    if (product.is_delivered && product.delivery_date_expired) {
      return (
        <p className="info-message">
          {rmsConfig.only_replacement
            ? "Replacement"
            : rmsConfig.supports_exchange && rmsConfig.supports_refund
              ? "Return/Exchange"
              : rmsConfig.supports_exchange
                ? "Exchange"
                : "Return"}{" "}
          period is expired
        </p>
      );
    }

    const getButtonSizeStyles = (buttons) => {
      const visibleButtons = buttons.filter(Boolean);
      const buttonCount = visibleButtons.length;

      if (buttonCount === 0) {
        return {};
      }

      const totalGap = Math.max(buttonCount - 1, 0) * BUTTON_CONTAINER_GAP;
      const isButtonVersionV1 = rmsConfig.button_version === "v1";
      const hasExchangeAndReturn =
        visibleButtons.includes("exchange") &&
        visibleButtons.includes("return");

      const baseShares = visibleButtons.reduce((acc, button) => {
        acc[button] = buttonCount > 1 ? 45 : 100;
        return acc;
      }, {});

      if (buttonCount === 2 && !isButtonVersionV1 && hasExchangeAndReturn) {
        baseShares.exchange = 80;
        baseShares.return = 20;
      }

      const totalShare = visibleButtons.reduce(
        (sum, button) => sum + (baseShares[button] || 0),
        0,
      );

      return visibleButtons.reduce((acc, button) => {
        if (buttonCount === 1) {
          acc[button] = {
            width: "100%",
            maxWidth: "100%",
            flexBasis: "100%",
            flexGrow: 0,
            flexShrink: 0,
          };
          return acc;
        }

        const normalizedShare =
          totalShare > 0 ? baseShares[button] / totalShare : 1 / buttonCount;
        const shareValue = Number(normalizedShare.toFixed(4));
        const widthValue =
          totalGap > 0
            ? `calc((100% - ${totalGap}px) * ${shareValue})`
            : `${shareValue * 100}%`;

        const minWidthValue =
          buttonCount > 1
            ? `min(${MIN_BUTTON_WIDTH}px, ${widthValue})`
            : `${MIN_BUTTON_WIDTH}px`;

        acc[button] = {
          width: widthValue,
          maxWidth: widthValue,
          flexBasis: widthValue,
          flexGrow: 0,
          flexShrink: 0,
          minWidth: minWidthValue,
        };

        return acc;
      }, {});
    };

    if (
      rmsConfig.restrict_multi_type_request_creation &&
      returnedProducts.length > 0 &&
      (product.refund_eligible ||
        product.exchange_eligible ||
        isReplacementAvailable(product)) &&
      product.remaining_qty > 0
    ) {
      const showExchangeButton =
        customerCanExchange &&
        !product.exchange_date_expired &&
        returnedProducts.some((a) => a.return_type === "exchange") &&
        product.exchange_eligible;

      const showReturnButton =
        rmsConfig.supports_refund &&
        !product.return_date_expired &&
        returnedProducts.some((a) => a.return_type === "refund") &&
        product.refund_eligible;

      const showReplaceButton =
        isReplacementAvailable(product) &&
        returnedProducts.some((a) => a.return_type === "replacement");

      const visibleButtons = [
        showExchangeButton ? "exchange" : null,
        showReplaceButton ? "replace" : null,
        showReturnButton ? "return" : null,
      ];
      const visibleButtonCount = visibleButtons.filter(Boolean).length;

      if (visibleButtonCount === 0) {
        return renderRestrictionMessage(
          product.exchange_restrict_msg ||
            product.refund_restrict_msg ||
            "This item is not eligible for the selected request type",
        );
      }

      const buttonSizeStyles = getButtonSizeStyles(visibleButtons);

      return (
        <div>
          <div className="button-container">
            {showExchangeButton &&
              renderButton(
                "Exchange",
                () => handleExchangeClick(false),
                !product.exchange_eligible,
                <RepeatIcon />,
                {
                  minWidth: `${MIN_BUTTON_WIDTH}px`,
                  ...(buttonSizeStyles.exchange || {}),
                },
                null,
                "exchange",
                isExchangeActive,
              )}
            {showReplaceButton &&
              renderButton(
                "Replace",
                () => handleExchangeClick(true),
                false,
                <RepeatIcon />,
                {
                  minWidth: `${MIN_BUTTON_WIDTH}px`,
                  ...(buttonSizeStyles.replace || {}),
                },
                null,
                "replace",
                isReplaceActive,
              )}
            {showReturnButton &&
              renderButton(
                rmsConfig.button_version !== "v2" ? "Return" : "",
                () => handleReturnClick(),
                !product.refund_eligible,
                rmsConfig.button_version === "v3" ||
                  rmsConfig.button_version === "v4" ? (
                  ""
                ) : (
                  <ReplayIcon />
                ),
                {
                  minWidth: `${MIN_BUTTON_WIDTH}px`,
                  ...(buttonSizeStyles.return || {}),
                  display: "flex",
                  flexDirection:
                    rmsConfig.button_version === "v4" ? "column" : "row",
                  background: "#f9fafc",
                  border: merchantConfig.merchant_id === 977 ? "1px solid #E3E6EE" : `1px solid ${merchantConfig.primary_theme_color}`
                },
                rmsConfig.button_version === "v4" &&
                  rmsConfig.base_refund_charge &&
                  rmsConfig.base_refund_charge !== null &&
                  `Extra ${rmsConfig.base_refund_charge}*`,
                "return",
                isReturnActive,
              )}
            {rmsConfig.button_promotional_text &&
              rmsConfig.button_promotional_text !== "" && (
                <p
                  className="incentivise-message"
                  style={styles.incentiviseMessage}
                >
                  {rmsConfig.button_promotional_text}
                </p>
              )}
          </div>

          {renderExpiryInfo(showExchangeButton, showReturnButton, {
            borderRadius: merchantConfig.use_rounded_edge_buttons
              ? "10px"
              : "0px",
          })}

          {!product.exchange_eligible &&
            renderRestrictionMessage(
              product.exchange_restrict_msg ||
                `This item is not eligible for ${
                  rmsConfig.only_replacement ? "replace" : "exchange"
                }`,
            )}

          {!product.refund_eligible &&
            product.refund_restrict_msg &&
            renderRestrictionMessage(product.refund_restrict_msg)}
        </div>
      );
    }

    if (
      product.eligible &&
      (product.refund_eligible ||
        product.exchange_eligible ||
        isReplacementAvailable(product)) &&
      product.remaining_qty > 0
    ) {
      const showExchangeButton =
        customerCanExchange &&
        !product.exchange_date_expired &&
        product.exchange_eligible;

      const showReturnButton =
        rmsConfig.supports_refund &&
        !product.return_date_expired &&
        product.refund_eligible;

      const showReplaceButton = isReplacementAvailable(product);

      const visibleButtons = [
        showExchangeButton ? "exchange" : null,
        showReplaceButton ? "replace" : null,
        showReturnButton ? "return" : null,
      ];
      const visibleButtonCount = visibleButtons.filter(Boolean).length;

      if (visibleButtonCount === 0) {
        return renderRestrictionMessage(
          product.exchange_restrict_msg ||
            product.refund_restrict_msg ||
            "This item is not eligible for the available request actions",
        );
      }

      const buttonSizeStyles = getButtonSizeStyles(visibleButtons);

      return (
        <div>
          <div className="button-container">
            {showExchangeButton &&
              renderButton(
                "Exchange",
                () => handleExchangeClick(false),
                !product.exchange_eligible,
                <RepeatIcon />,
                {
                  minWidth: `${MIN_BUTTON_WIDTH}px`,
                  ...(buttonSizeStyles.exchange || {}),
                },
                null,
                "exchange",
                isExchangeActive,
              )}
            {showReplaceButton &&
              renderButton(
                "Replace",
                () => handleExchangeClick(true),
                false,
                <RepeatIcon />,
                {
                  minWidth: `${MIN_BUTTON_WIDTH}px`,
                  ...(buttonSizeStyles.replace || {}),
                },
                null,
                "replace",
                isReplaceActive,
              )}
            {showReturnButton &&
              renderButton(
                rmsConfig.button_version !== "v2" ? "Return" : "",
                () => handleReturnClick(),
                !product.refund_eligible,
                rmsConfig.button_version === "v3" ||
                  rmsConfig.button_version === "v4" ? (
                  ""
                ) : (
                  <ReplayIcon />
                ),
                {
                  minWidth: `${MIN_BUTTON_WIDTH}px`,
                  ...(buttonSizeStyles.return || {}),
                  display: "flex",
                  flexDirection:
                    rmsConfig.button_version === "v4" ? "column" : "row",
                  background: "#f9fafc",
                  border: merchantConfig.merchant_id === 977 ? "1px solid #E3E6EE" : `1px solid ${merchantConfig.primary_theme_color}`
                },
                rmsConfig.button_version === "v4" &&
                  rmsConfig.base_refund_charge &&
                  rmsConfig.base_refund_charge !== null &&
                  `Extra ${rmsConfig.base_refund_charge}*`,
                "return",
                isReturnActive,
              )}
          </div>

          {rmsConfig.button_promotional_text &&
            rmsConfig.button_promotional_text !== "" && (
              <p
                className="incentivise-message"
                style={styles.incentiviseMessage}
              >
                {rmsConfig.button_promotional_text}
              </p>
            )}

          {renderExpiryInfo(showExchangeButton, showReturnButton, {
            borderRadius: merchantConfig.use_rounded_edge_buttons
              ? "10px"
              : "0px",
            background:
              merchantConfig.merchant_id === "977"
                ? "#E6EEFF"
                : `color-mix(in srgb, ${merchantConfig.primary_theme_color} 15%, white)`,
          })}

          {!product.exchange_eligible &&
            product.exchange_restrict_msg &&
            renderRestrictionMessage(product.exchange_restrict_msg)}

          {!product.refund_eligible &&
            product.refund_restrict_msg &&
            renderRestrictionMessage(product.refund_restrict_msg)}

          {product.errors?.length > 0 &&
            product.errors.map((err, idx) => (
              <p className="info-message" key={idx}>
                {err.error_code_message}
              </p>
            ))}
        </div>
      );
    }

    if (product.remaining_qty > 0) {
      return (
        <p className="info-message">
          This item is not eligible for{" "}
          {rmsConfig.only_replacement ? "replacement" : "return or exchange"}
        </p>
      );
    }

    return (
      <div>
        <p className="info-message">
          You've already placed a{" "}
          {rmsConfig.only_replacement ? "replacement" : "return/exchange"} for
          this item.
          {!trackingReferenceId &&
            " Please reach out to us by clicking on the Need Help button at the bottom of the page for further assistance."}
        </p>
        {renderTrackRequestButton(trackingReferenceId)}
      </div>
    );
  };

  function handleOnSelect(return_type, product, options = {}) {
    const { isReplacement = false } = options;

    dispatch(addSelectedReason(null));
    dispatch(addSelectedSubReason(null));
    dispatch(setImageUploads([]));
    dispatch(addPreviews([]));
    dispatch(addUploads([]));
    dispatch(addProductType(null));
    dispatch(addProceedBool(false));
    dispatch(setReplacementMode(isReplacement));

    if (isReplacement) {
      dispatch(addProductType("same"));
    }

    if (product.product_group_id && product.product_group_id !== null) {
      let groupProducts = selectedOrder.order_items.filter(
        (newProduct) =>
          newProduct.product_group_id === product.product_group_id,
      );
      if (product.is_parent) {
        dispatch(addSelectedProduct(product));
        dispatch(addSelectedGroupProducts(groupProducts));
        dispatch(addProductid(product.line_item_id + return_type));
        setProductid(product.line_item_id + return_type);
        setSelectedProduct(product);
      } else {
        const parentProduct = groupProducts.filter(
          (groupProduct) => groupProduct.is_parent === true,
        );

        if (parentProduct && parentProduct.length > 0) {
          dispatch(addSelectedProduct(parentProduct[0]));
          setSelectedProduct(parentProduct[0]);
          dispatch(addSelectedGroupProducts(groupProducts));
          dispatch(addProductid(parentProduct[0].line_item_id + return_type));
          setProductid(parentProduct[0].line_item_id + return_type);
        }
      }
    } else {
      dispatch(addSelectedProduct(product));
      setSelectedProduct(product);
      dispatch(addSelectedGroupProducts([]));
      dispatch(addProductid(product.line_item_id + return_type));
      setProductid(product.line_item_id + return_type);
    }
  }

  const renderProductPrice = (item) => {
    if (!item || item.product_price == null) {
      return null;
    }

    if (item.total_item_discount > 0) {
      return (
        <span>
          ₹ {item.discounted_price}{" "}
          <span
            style={{
              textDecoration: "line-through",
              fontSize: "14px",
              marginLeft: "4px",
              fontWeight: "400",
            }}
          >
            ₹{item.original_product_price}
          </span>
        </span>
      );
    }

    return `₹ ${item.product_price}`;
  };

  const ProductCard = ({ product, webSelected }) => {
    const currentProduct =
      selectedOrder.order_items?.filter(
        (a) => a.line_item_id === product.line_item_id,
      ) || [];

    const priceMarkup = renderProductPrice(product);

    return (
      <div
        style={{
          background: "#fff",
          borderBottom:
            product.line_item_id !== undefined &&
            productid !== null &&
            productid.includes(product.line_item_id)
              ? `1px solid ${merchantConfig.primary_theme_color}`
              : "1px solid #11111133",
          position: "relative",
          width: "100%",
          maxWidth: "700px",
        }}
      >
        <StyledProducts rounded={merchantConfig.use_rounded_edge_buttons}>
          {(currentProduct[0].quantity - product.quantity > 0 ||
            product.returned_qty > 0) &&
            product.remaining_qty > 0 && (
              <p
                className="top-banner"
                style={{
                  background: "#3B444D",
                  color: "#fff",
                  position: "absolute",
                  top: "0",
                  left: "0",
                  padding: "4px 8px",
                  fontSize: "12px",
                }}
              >
                {currentProduct[0].quantity - product.quantity || [
                  product.returned_qty,
                ]}{" "}
                qty added to return cart
              </p>
            )}

          <LazyLoadImage
            effect="opacity"
            src={product.image_url}
            alt={product.product_title}
            className="product-image"
          />
          <div className="product-details">
            <p
              style={{
                color: merchantConfig.primary_theme_color,
              }}
              className="product-title"
            >
              {product.product_title}
            </p>
            <p className="margin">{product.variant_name}</p>
            <p className="margin">
              Quantity:{" "}
              {product.remaining_qty > 0
                ? product.remaining_qty
                : product.quantity}
            </p>
            {priceMarkup && (
              <p className="margin" style={{ fontWeight: "600" }}>
                {priceMarkup}
              </p>
            )}
            {/* <div className="radio-buttons">
              <RefundButtons product={product} />
            </div> */}
          </div>
        </StyledProducts>
        {/* <StyledMobButtons> */}
        <RefundButtons product={product} />
        {/* </StyledMobButtons> */}
      </div>
    );
  };

  const ProductGroupCard = ({ group }) => {
    const parent = group.parent;
    const children = group.children || [];

    const aggregatedProduct = useMemo(
      () => aggregateGroupProduct(parent, children),
      [parent, children],
    );

    const parentTitle =
      parent?.product_title ||
      parent?.parent_title ||
      children[0]?.parent_title ||
      children[0]?.product_title ||
      "";

    const parentVariant =
      parent?.variant_name ||
      parent?.parent_variant ||
      children[0]?.parent_variant ||
      "";

    const parentQuantity =
      parent?.remaining_qty && parent.remaining_qty > 0
        ? parent.remaining_qty
        : parent?.quantity ||
          parent?.parent_quantity ||
          children[0]?.parent_quantity;

    const parentPriceMarkup = renderProductPrice(parent);

    const parentImage =
      parent?.parent_image_url ||
      parent?.image_url ||
      children.find((child) => child.parent_image_url)?.parent_image_url ||
      children.find((child) => child.image_url)?.image_url ||
      "";

    const isAnyChildSelected = children.some(
      (child) =>
        child.line_item_id !== undefined &&
        productid !== null &&
        productid.includes(child.line_item_id),
    );

    const isExpanded = expandedGroupKey === group.key;
    const actionType = isExpanded ? activeGroupAction : null;
    const isReplacementFlow = isExpanded ? isReplacementAction : false;
    const actionLabel = isReplacementFlow
      ? "replace"
      : actionType === "return"
        ? "return"
        : actionType === "exchange"
          ? "exchange"
          : null;

    const childrenContainerRef = useRef(null);
    const animationFrameRef = useRef(null);
    const initialRenderRef = useRef(true);
    const groupContainerRef = useRef(null);

    useEffect(() => {
      const element = childrenContainerRef.current;
      if (!element) {
        return;
      }

      const duration = 280;
      const easeInOut = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);

      const animate = (startHeight, endHeight) => {
        let startTime = null;

        const step = (timestamp) => {
          if (!startTime) {
            startTime = timestamp;
          }

          const elapsed = timestamp - startTime;
          const progress = Math.min(elapsed / duration, 1);
          const eased = easeInOut(progress);
          const height = startHeight + (endHeight - startHeight) * eased;

          element.style.height = `${height}px`;

          if (progress < 1) {
            animationFrameRef.current = requestAnimationFrame(step);
          } else {
            if (endHeight === 0) {
              element.style.display = "none";
              element.style.height = "0px";
              element.style.overflow = "hidden";
            } else {
              element.style.height = "auto";
              element.style.overflow = "visible";
            }
          }
        };

        animationFrameRef.current = requestAnimationFrame(step);
      };

      cancelAnimationFrame(animationFrameRef.current);

      if (initialRenderRef.current) {
        initialRenderRef.current = false;
        if (isExpanded) {
          element.style.display = "flex";
          element.style.height = "auto";
          element.style.overflow = "visible";
        } else {
          element.style.display = "none";
          element.style.height = "0px";
          element.style.overflow = "hidden";
        }
        return;
      }

      if (isExpanded) {
        element.style.display = "flex";
        element.style.overflow = "hidden";
        element.style.height = "auto";
        const targetHeight = element.scrollHeight;
        element.style.height = "0px";
        animate(0, targetHeight);
      } else {
        const currentHeight = element.scrollHeight;
        if (currentHeight === 0) {
          element.style.display = "none";
          element.style.height = "0px";
          element.style.overflow = "hidden";
        } else {
          element.style.overflow = "hidden";
          animate(currentHeight, 0);
        }
      }

      return () => {
        cancelAnimationFrame(animationFrameRef.current);
      };
    }, [isExpanded]);

    useEffect(() => {
      const element = childrenContainerRef.current;
      if (element && isExpanded) {
        element.style.display = "flex";
        element.style.height = "auto";
        element.style.overflow = "visible";
      }
    }, [isExpanded, children.length, actionType, isReplacementFlow]);

    useEffect(() => {
      if (!isExpanded || initialRenderRef.current) {
        return;
      }

      const element = groupContainerRef.current;
      if (!element) {
        return;
      }

      const rect = element.getBoundingClientRect();
      const scrollOffset = window.innerWidth > 900 ? 120 : 80;
      const target = window.pageYOffset + rect.top - scrollOffset;

      window.scrollTo({
        top: target > 0 ? target : 0,
        behavior: "smooth",
      });
    }, [isExpanded]);

    const selectedActionForButtons =
      isExpanded && actionType
        ? { type: actionType, isReplacement: isReplacementFlow }
        : null;

    return (
      <StyledComponentGroup
        primary_color={merchantConfig.primary_theme_color}
        className={isAnyChildSelected ? "selected" : ""}
        rounded={merchantConfig.use_rounded_edge_buttons}
        ref={groupContainerRef}
      >
        <div className="component-parent">
          <LazyLoadImage
            effect="opacity"
            src={parentImage}
            alt={parentTitle}
            className="component-parent-image"
          />
          <div className="product-details">
            <p
              style={{
                color: "#3B444D",
                lineHeight: "1.5em",
                maxHeight: "3em",
                overflow: "hidden",
              }}
            >
              {parentTitle}
            </p>
            {parentVariant && (
              <p className="margin" style={{ color: "#3B444DB2" }}>
                {parentVariant}
              </p>
            )}
            <div style={{ display: "flex" }}>
              {parentQuantity !== undefined && parentQuantity !== null && (
                <p className="margin" style={{ color: "#3B444DB2" }}>
                  Quantity: {parentQuantity}
                </p>
              )}
              {parentPriceMarkup && (
                <p
                  className="margin"
                  style={{
                    color: "#3B444DB2",
                    fontWeight: "600",
                    marginLeft: "auto",
                  }}
                >
                  {parentPriceMarkup}
                </p>
              )}
            </div>
          </div>
        </div>
        <div className="component-action-buttons">
          <RefundButtons
            product={aggregatedProduct}
            onActionClick={(action, options) =>
              handleGroupActionSelection(group.key, action, options)
            }
            selectedAction={selectedActionForButtons}
          />
        </div>
        <div ref={childrenContainerRef} className="component-children">
          {actionLabel && (
            <p className="component-child-message">
              Select the item you want to {actionLabel}.
            </p>
          )}
          {children.map((child) => {
            const currentProduct = selectedOrder.order_items?.find(
              (a) => a.line_item_id === child.line_item_id,
            );

            const showBanner =
              currentProduct &&
              (currentProduct.quantity - child.quantity > 0 ||
                child.returned_qty > 0) &&
              child.remaining_qty > 0;

            const addedQuantity = currentProduct
              ? currentProduct.quantity - child.quantity > 0
                ? currentProduct.quantity - child.quantity
                : child.returned_qty
              : child.returned_qty;

            const childSelected =
              child.line_item_id !== undefined &&
              productid !== null &&
              productid.includes(child.line_item_id);

            const childPriceMarkup = renderProductPrice(child);
            const childImage = child.image_url || parentImage;

            const { selectable, message, referenceId } = getChildActionState(
              child,
              actionType,
              isReplacementFlow,
            );
            const isSelectable = Boolean(actionType) && selectable;

            const childClasses = [
              "component-child",
              childSelected ? "selected" : "",
              isExpanded ? (isSelectable ? "selectable" : "disabled") : "",
            ]
              .filter(Boolean)
              .join(" ");

            const handleChildSelection = () => {
              if (!isSelectable) {
                return;
              }
              if (actionType === "return") {
                handleOnSelect("return", child, { isReplacement: false });
              } else if (actionType === "exchange") {
                handleOnSelect("exchange", child, {
                  isReplacement: isReplacementFlow,
                });
              }

              if (isDesktopReasonLayout) {
                dispatch(updateWebSelected(true));
                dispatch(mobSelected(false));
              } else {
                dispatch(mobSelected(true));
                dispatch(updateWebSelected(false));
              }
              setIncentiviseExchangeModalOpen(false);
            };

            return (
              <div
                key={child.line_item_id}
                className={childClasses}
                role={isSelectable ? "button" : "group"}
                tabIndex={isSelectable ? 0 : -1}
                aria-disabled={!isSelectable}
                onClick={handleChildSelection}
                onKeyDown={(event) => {
                  if (!isSelectable) {
                    return;
                  }
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    handleChildSelection();
                  }
                }}
              >
                {showBanner && addedQuantity > 0 && (
                  <p className="top-banner">
                    {addedQuantity} qty added to return cart
                  </p>
                )}
                <div className="child-body">
                  <LazyLoadImage
                    effect="opacity"
                    src={childImage}
                    alt={child.product_title}
                    className="child-image"
                  />
                  <div className="child-info">
                    <p
                      className="title"
                      style={{
                        color: "#3B444D",
                        lineHeight: "1.5em",
                        maxHeight: "3em",
                        overflow: "hidden",
                      }}
                    >
                      {child.product_title}
                    </p>
                    {child.variant_name && (
                      <p className="margin">{child.variant_name}</p>
                    )}
                    <div style={{ display: "flex" }}>
                      <p className="margin">
                        Quantity:{" "}
                        {child.remaining_qty > 0
                          ? child.remaining_qty
                          : child.quantity}
                      </p>
                      {/* {childPriceMarkup && (
                        <p
                          className="margin price"
                          style={{ marginLeft: "auto" }}
                        >
                          {childPriceMarkup}
                        </p>
                      )} */}
                    </div>
                  </div>
                </div>
                {isExpanded && !isSelectable && message && (
                  <>
                    <p className="info-message">{message}</p>
                    {renderTrackRequestButton(referenceId)}
                  </>
                )}
              </div>
            );
          })}
        </div>
      </StyledComponentGroup>
    );
  };

  const StyledApp = styled.div`
    .product-tag-consent {
      color: #b81414;
      background: #f9c8c8;
      max-width: 100%;
      margin: 0px 1rem;
      text-align: center;
      position: fixed;
      bottom: 90px;
      padding: 10px;
      z-index: 25;
      line-height: 1.25rem;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      border-radius: ${merchantConfig.use_rounded_edge_buttons ? "4px" : "0px"};
    }

    @media (min-width: 800px) {
      .product-tag-consent {
        bottom: 35px;
        background: transparent;
        font-size: 14px;
        left: 4%;
        max-width: 60%;
        text-align: left;
      }
    }
  `;

  return (
    <StyledApp>
      {currentPath === "/products" && (
        <Header
          ordername={
            selectedOrder && selectedOrder !== null && selectedOrder.order_name
          }
          disabled={updatedReturnedProducts.length === 0}
        />
      )}
      {apiErrorLoading ? (
        <LoadingError minHeight="80vh" />
      ) : (
        <StyledProductsWrapper
          location={currentPath}
          returnedProducts={returnedProducts}
          primary_color={merchantConfig.primary_theme_color}
          rounded={merchantConfig.use_rounded_edge_buttons}
        >
          {productsLoading ? (
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {[...Array(4).keys()].map((a) => {
                return (
                  <div className="products-skeleton" key={a}>
                    <Skeleton
                      variant="rectangular"
                      className="image-skeleton"
                    />
                    <div style={{ marginLeft: "20px", marginTop: "10px" }}>
                      <Typography className="text-skeleton" variant="h4">
                        {" "}
                        <Skeleton variant="text" />
                      </Typography>
                      <Typography className="text-skeleton" variant="h4">
                        {" "}
                        <Skeleton variant="text" />
                      </Typography>
                      <Typography className="text-skeleton" variant="h4">
                        {" "}
                        <Skeleton variant="text" />
                      </Typography>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="products-wrapper">
              {selectedProduct && selectedProduct.image_url && animate && (
                <img
                  className="add-to-cart-image"
                  src={selectedProduct.image_url}
                />
              )}
              {updatedReturnedProducts.length > 0 && (
                <div className="products-return">
                  <Accordion
                    className="accordion"
                    style={{
                      width: "100%",
                      boxShadow: "none",
                      zIndex: "99",
                      marginBottom: "1rem",
                      borderRadius: merchantConfig.use_rounded_edge_buttons
                        ? "10px"
                        : "0px",
                      maxWidth: "700px",
                    }}
                    sx={{
                      borderRadius: merchantConfig.use_rounded_edge_buttons
                        ? "10px"
                        : "0px",
                      "&:before": { display: "none" }, // removes default divider line
                      overflow: "hidden", // ensures rounded edges are clipped
                    }}
                  >
                    <AccordionSummary
                      expandIcon={
                        <ExpandMoreIcon
                          style={{
                            color: merchantConfig.primary_theme_color,
                          }}
                        />
                      }
                      aria-controls="panel1-content"
                      style={{
                        background: merchantConfig.merchant_id === 977 ? "#DFE6F7" : `${merchantConfig.primary_theme_color}33`,
                        color: merchantConfig.primary_theme_color,
                      }}
                    >
                      <p style={{ fontWeight: "700", letterSpacing: "1px" }}>
                        {returnedProducts.length > 0
                          ? returnedProducts.length
                          : "No"}{" "}
                        item
                        {(returnedProducts.length > 1 ||
                          returnedProducts.length === 0) &&
                          "s"}{" "}
                        in the return cart
                      </p>
                    </AccordionSummary>
                    <AccordionDetails
                      style={{
                        maxHeight: "450px",
                        height: "100%",
                        overflowY: "auto",
                        padding: "0",
                      }}
                    >
                      <Grid
                        alignItems="center"
                        container
                        gridTemplateColumns="repeat(12, 1fr)"
                        className="cart-products"
                      >
                        {updatedReturnedProducts.length > 0 &&
                          updatedReturnedProducts.map((product, i) => {
                            return (
                              <Grid
                                key={i}
                                justifyContent="center"
                                item
                                xs={12}
                                sx={{}}
                              >
                                <CartProducts
                                  cart_type="yet_to_create"
                                  product={product}
                                  location={currentPath}
                                  returnedProducts={updatedReturnedProducts}
                                  outOfStock={null}
                                />
                              </Grid>
                            );
                          })}
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                </div>
              )}
              {currentPath === "/products" && (
                <div>
                  {selectedOrder.order_items.length === 0 ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        margin: "1.5rem 0",
                        maxWidth: "700px",
                      }}
                    >
                      {/* <img src={cartImage} style={{ height: "100px" }} /> */}
                      <p
                        style={{
                          padding: "1rem",
                          fontWeight: "700",
                          textAlign: "center",
                          lineHeight: "1.5rem",
                          fontSize: "16px",
                          color: "#3b444d"
                        }}
                      >
                        No other items found for this order
                      </p>
                    </div>
                  ) : selectedOrder.order_items.length === 0 &&
                    updatedReturnedProducts.length > 0 ? (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        margin: "1.5rem 0",
                        maxWidth: "700px",
                      }}
                    >
                      {/* <img src={cartImage} style={{ height: "100px" }} /> */}
                      <p
                        style={{
                          padding: "1rem",
                          fontWeight: "700",
                          textAlign: "center",
                          lineHeight: "1.5rem",
                          fontSize: "16px",
                          color: "#3b444d"
                        }}
                      >
                        All eligible return items have been added.
                      </p>
                    </div>
                  ) : (
                    <div className="select-products">
                      {updatedReturnedProducts.length > 0
                        ? `Add more items to ${
                            rmsConfig.only_replacement
                              ? " replace"
                              : customerCanExchange &&
                                  rmsConfig.supports_refund
                                ? " return or exchange"
                                : customerCanExchange
                                  ? " exchange"
                                  : " return"
                          }`
                        : `Select products for ${
                            rmsConfig.only_replacement
                              ? " replace"
                              : customerCanExchange &&
                                  rmsConfig.supports_refund
                                ? " return or exchange"
                                : customerCanExchange
                                  ? " exchange"
                                  : " return"
                          }`}
                    </div>
                  )}
                </div>
              )}
              <Grid
                direction="column"
                container
                rowSpacing={{ xs: 2, md: 4 }}
                className="products-grid"
              >
                {eligibleDisplayItems.map((entry) => {
                  if (entry.type === "group") {
                    return (
                      <Grid
                        key={entry.key}
                        justifyContent="center"
                        item
                        xs={12}
                      >
                        <ProductGroupCard group={entry} />
                      </Grid>
                    );
                  }

                  if (!entry.item) {
                    return null;
                  }

                  return (
                    <Grid
                      key={entry.item.line_item_id}
                      justifyContent="center"
                      item
                      xs={12}
                    >
                      <ProductCard
                        product={entry.item}
                        key={entry.item.line_item_id}
                        webSelected={webSelected}
                      />
                    </Grid>
                  );
                })}

                {ineligibleDisplayItems.map((entry) => {
                  if (entry.type === "group") {
                    return (
                      <Grid
                        key={`ineligible-${entry.key}`}
                        justifyContent="center"
                        item
                        xs={12}
                      >
                        <ProductGroupCard group={entry} />
                      </Grid>
                    );
                  }

                  if (!entry.item) {
                    return null;
                  }

                  return (
                    <Grid
                      key={`ineligible-${entry.item.line_item_id}`}
                      justifyContent="center"
                      item
                      xs={12}
                    >
                      <ProductCard
                        product={entry.item}
                        key={entry.item.line_item_id}
                        webSelected={webSelected}
                      />
                    </Grid>
                  );
                })}
              </Grid>
              {webSelected && isDesktopReasonLayout && (
                <div
                  style={{
                    margin: "auto",
                    position: "fixed",
                    width: "50%",
                    right: "0",
                    top:
                      currentPath === "/return-cart" ? "118px" : "105px",
                    zIndex: "99",
                  }}
                >
                  <Reason
                    handleOnSelect={handleOnSelect}
                    setAnimate={setAnimate}
                  />
                </div>
              )}
              {(selected || (webSelected && !isDesktopReasonLayout)) && (
                <Drawer
                  style={{ maxHeight: "90vh", background: "transparent" }}
                  anchor="bottom"
                  open={selected || (webSelected && !isDesktopReasonLayout)}
                  onClose={() => dispatch(mobSelected(true))}
                >
                  <Reason
                    handleOnSelect={handleOnSelect}
                    setAnimate={setAnimate}
                  />
                </Drawer>
              )}
              {/* {location.pathname === "/products" && (
                <p
                  onClick={() => navigate(`/?encipherencode=${encipherencode}`)}
                  className="change-user"
                >
                  Change Phone/Email ?
                </p>
              )} */}
              {/* {location.pathname === "/products" &&
                merchantConfig.whatsapp_help &&
                merchantConfig.whatsapp_help !== null && (
                  <a
                    href={merchantConfig.whatsapp_help}
                    target="_blank"
                    rel="noreferrer"
                    className="help"
                    style={{
                      fontWeight: "600",
                      fontSize: "12px",
                      color: "var(--color-primary)",
                      margin: "60px 0px",
                      textDecoration: "underline",
                      display: "block",
                    }}
                  >
                    Need Help?
                  </a>
                )} */}

              {updatedReturnedProducts.length > 0 && (
                <div className="mob-view-cart-btn">
                  {rmsConfig.product_tag_consent &&
                    rmsConfig.product_tag_consent_text !== "" &&
                    currentPath === "/products" && (
                      <p className="product-tag-consent">
                        {rmsConfig.product_tag_consent_text}
                      </p>
                    )}
                  <Button
                    variant="contained"
                    fullWidth
                    style={{
                      borderRadius: merchantConfig.use_rounded_edge_buttons
                        ? "4px"
                        : "0px",
                    }}
                    onClick={() => {
                      saveReturnCartContext({
                        selectedOrder,
                        returnedProducts: updatedReturnedProducts,
                        shipmentMethod,
                        refundSource,
                        refundJSON,
                        addressDetails,
                      });
                      let url = versionedPath("/return-cart", location.pathname);
                      if (encipherencode) {
                        url += `?encipherencode=${encipherencode}`;
                      }
                      navigate(url);
                    }}
                  >
                    Proceed to
                    {proceedActionText} <ArrowRightAltIcon />
                  </Button>
                </div>
              )}
            </div>
          )}
        </StyledProductsWrapper>
      )}

      <Modal
        aria-labelledby="Incentvise Exchange"
        aria-describedby="Incentivising Exchange over Return of a product"
        open={incentiviseExchangeModalOpen}
        onClose={() => {
          setIncentiviseExchangeModalOpen(false);
          setPendingIncentiviseSelection(null);
        }}
        closeAfterTransition
        themePrimaryColor={merchantConfig.primary_theme_color}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            minWidth: "300px",
            padding: "20px 30px 30px",
            background: "#fff",
            maxWidth: "600px",
            borderRadius: "10px",
            width: "90%",
          }}
        >
          <div
            style={{ textAlign: "right", cursor: "pointer" }}
            onClick={() => {
              setIncentiviseExchangeModalOpen(false);
              setPendingIncentiviseSelection(null);
            }}
          >
            <CloseIcon />
          </div>
          <div style={{ textAlign: "center", marginTop: "10px" }}>
            <p className="nudge-title">{rmsConfig.exchange_nudge_title}</p>
            <p className="nudge-description">
              {rmsConfig.exchange_nudge_description}
            </p>
            <div style={{ marginTop: "20px" }}>
              {customerCanExchange &&
                !pendingIncentiviseSelection?.product?.exchange_date_expired &&
                pendingIncentiviseSelection?.product?.exchange_eligible &&
                renderButton(
                  "Exchange",
                  () => {
                    if (!pendingIncentiviseSelection?.product) {
                      return;
                    }
                    openReasonFlow(
                      "exchange",
                      pendingIncentiviseSelection.product,
                      {
                        isReplacement: false,
                      },
                    );
                  },
                  !pendingIncentiviseSelection?.product?.exchange_eligible,
                  <RepeatIcon />,
                  {
                    width: "100%",
                    background: merchantConfig.primary_theme_color,
                    color: merchantConfig.secondary_theme_color,
                  },
                  null,
                  true,
                )}
              <p
                style={{
                  color: merchantConfig.primary_theme_color,
                  marginTop: "10px",
                  fontSize: "13px",
                  cursor: "pointer",
                }}
                onClick={() => {
                  if (!pendingIncentiviseSelection?.product) {
                    setIncentiviseExchangeModalOpen(false);
                    setPendingIncentiviseSelection(null);
                    return;
                  }
                  openReasonFlow(
                    pendingIncentiviseSelection.returnType || "return",
                    pendingIncentiviseSelection.product,
                    {
                      isReplacement:
                        pendingIncentiviseSelection.isReplacement || false,
                    },
                  );
                }}
              >
                No, thanks! I'll proceed with the return.
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </StyledApp>
  );
}

export default ProductsDisplay;
